export default __webpack_public_path__ + "images/8b426feacdf4e2d5fa874a7f5eff2173-right-arrow.svg";